<template>
  <div class="templates-complement-modal">
    <div class="modal-backdrop"></div>

    <div class="modal fade show d-block">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="submit" class="modal-body p-lg-5">
            <div class="row">
              <div class="col-lg-6 order-lg-2">
                <div class="video-wrapper">
                  <div class="embed-responsive embed-responsive-16by9">
                    <iframe
                      class="embed-responsive-item"
                      src="https://player.scaleup.com.br/embed/0991235ebbf5df55372c9a7ed68a355a1738d28e"
                      frameborder="0"
                    ></iframe>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 order-lg-1">
                <h3 class="mb-4">Bem-vindo(a) ao M60!</h3>
                <div class="form-body">
                  <p class="mb-4">
                    Antes de começarmos sua jornada internacional, queremos
                    conhecer um pouco mais sobre você. Essas perguntas rápidas
                    vão nos ajudar a personalizar sua experiência, indicar
                    oportunidades sob medida e entender melhor seus sonhos.
                  </p>
                  <form-group
                    label="Qual a sua data de nascimento?"
                    required
                    id="birthday"
                    mask="##/##/####"
                    placeholder="DD/MM/AAAA"
                    masked
                    v-model="form.birthday"
                    :errors="errors.birthday"
                  />
                  <form-group
                    label="Profissão"
                    placeholder="Digite aqui"
                    required
                    id="profession"
                    v-model="form.profession"
                    :errors="errors.profession"
                  />
                  <form-group
                    label="Qual região do mundo é seu destino dos sonhos?"
                    placeholder="Selecione"
                    required
                    id="destiny"
                    select
                    :options="destinyOptions"
                    v-model="form.destiny"
                    :errors="errors.destiny"
                  />
                  <form-group
                    label="Como você avalia seu nível atual de inglês?"
                    placeholder="Selecione"
                    required
                    id="english"
                    select
                    :options="englishOptions"
                    v-model="form.english"
                    :errors="errors.english"
                  />
                  <form-group
                    label="Qual sua escolaridade?"
                    placeholder="Selecione"
                    required
                    id="schooling"
                    select
                    :options="schoolingOptions"
                    v-model="form.schooling"
                    :errors="errors.schooling"
                  />
                  <form-group
                    label="Qual sua área de interesse?"
                    placeholder="Selecione"
                    required
                    id="area"
                    select
                    :options="areaOptions"
                    v-model="form.area"
                    :errors="errors.area"
                  />
                  <form-group
                    label="O que mais te motivou a se inscrever no M60 agora?"
                    placeholder="Digite aqui"
                    required
                    id="motivation"
                    v-model="form.motivation"
                    :errors="errors.motivation"
                  />
                  <form-group
                    label="Qual seu maior desafio ou dúvida hoje sobre estudar/trabalhar/morar fora?"
                    placeholder="Digite aqui"
                    required
                    id="challenge"
                    v-model="form.challenge"
                    :errors="errors.challenge"
                  />
                </div>

                <div
                  class="d-flex mx-n3 justify-content-center align-items-center mt-3"
                >
                  <!-- <button
                    type="button"
                    class="btn btn-secondary px-lg-5 px-4 mx-3"
                    @click="$emit('close')"
                  >
                    Preencher depois
                  </button> -->
                  <div class="flex-fill"></div>
                  <button
                    type="submit"
                    class="btn btn-primary px-lg-5 px-4 mx-3"
                  >
                    <loading :show="loading">Salvar</loading>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";

const buildOptions = arr => arr.map(id => ({ id, name: id }));

export default {
  data() {
    const destinyOptions = buildOptions([
      "EUA",
      "Canadá",
      "Europa",
      "Ásia",
      "Oceania",
      "América Latina"
    ]);
    const englishOptions = buildOptions([
      "Nunca estudei",
      "Iniciante",
      "Intermediário",
      "Avançado",
      "Fluente"
    ]);
    const schoolingOptions = buildOptions([
      "Ensino Fundamental",
      "Ensino Médio (público)",
      "Ensino Médio (privado/particular)",
      "Universitário (cursando)",
      "Ensino Superior (completo)",
      "Pós-Graduação / Mestrado",
      "Doutorado / Pós-Doutorado"
    ]);
    const areaOptions = buildOptions([
      "Ainda não tenho certeza",
      "Exatas & Engenharias",
      "Humanas & Sociais",
      "Biológicas",
      "Saúde & Medicina",
      "Artes"
    ]);

    return {
      destinyOptions,
      englishOptions,
      schoolingOptions,
      areaOptions,
      lesson: {
        id: 3,
        stream_url:
          "https://b-vz-ab7bef4e-bdd.tv.pandavideo.com.br/b4cd6175-ba66-44b6-8671-c8c763ba76ec/playlist.m3u8"
      },
      ...formFields([
        "motivation",
        "profession",
        "challenge",
        "birthday",
        "destiny",
        "english",
        "schooling",
        "area"
      ])
    };
  },
  computed: {
    ...mapState("courses", ["recommendedOptions"])
  },
  mounted() {
    document.body.classList.add("modal-open");
  },
  destroyed() {
    document.body.classList.remove("modal-open");
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("user/update", { complement: this.form })
        .then(() => {
          this.$emit("close");
          this.$message.success("Salvo com sucesso");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.templates-complement-modal {
  h3 {
    font-size: 32px;
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    letter-spacing: 0.1px;
  }

  .video-wrapper {
    margin-bottom: 24px;

    @media screen and (min-width: 992px) {
      position: sticky;
      top: 32px;
    }
  }
  .form-body {
    max-height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 8px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: #9a9a9a;
      margin-top: 15px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
}
</style>
